export default __webpack_public_path__ + "static/media/tasting.4bd550be.jpg";